export default "__VITE_ASSET__a6ef1a1a__"